export const orientationOptions = [
  {
    value: 0,
    name: "Landscape",
    label: "L",
    classes: "landscape"
  },
  {
    value: 90,
    name: "Portrait",
    label: "P",
    classes: "portrait"
  },
  {
    value: 180,
    name: "Landscape (flipped)",
    label: "L",
    classes: "landscape"
  },
  {
    value: 270,
    name: "Portrait (flipped)",
    label: "P",
    classes: "portrait"
  }
];